import React from 'react';
import { array } from 'prop-types';
import get from 'lodash/get';

import {
  SCAlertBox,
  Header,
  Text,
  AdminImage,
  RejectBox,
  TextBox,
} from './styles';

AlertBox.propTypes = {
  rejections: array.isRequired, // eslint-disable-line react/forbid-prop-types
};

const cutString = fileName => {
  let cutFileName = fileName;
  if (fileName !== undefined && fileName.indexOf('&#') > -1) {
    cutFileName = fileName.substring(0, fileName.indexOf('&#timestamp'));
  }
  return cutFileName;
};

function AlertBox({ rejections }) {
  const renderedRejections = rejections.map(rejection => (
    <RejectBox key={rejection.approvalStatus.date}>
      <AdminImage
        alt="adminImage"
        src={get(rejection, 'approvalStatus.admin.picture')}
      />
      <TextBox key={rejection.approvalStatus.date}>
        <Header>
          {' '}
          {get(rejection, 'approvalStatus.admin.name')} har nekat filen{' '}
          <b>&quot;{cutString(rejection.fileName)}&quot;</b> med meddelandet:
        </Header>{' '}
        <Text>{rejection.approvalStatus.message}</Text>
      </TextBox>
    </RejectBox>
  ));
  return <SCAlertBox>{renderedRejections}</SCAlertBox>;
}

export default AlertBox;



// WEBPACK FOOTER //
// ./src/components/AlertBox/AlertBox.js